import React, { Component } from 'react';
import uuid from 'uuid/v4';
import { Player, PlayerEvent } from 'bitmovin-player';
import { UIFactory } from 'bitmovin-player-ui';
import 'bitmovin-player-ui/dist/css/bitmovinplayer-ui.min.css'

export default class VideoPlayerHLS extends Component {
  constructor(props) {
    super(props);

    this.state = {
      src: props.src,
      bitmovinPlayer: null,
      bitmovinPlayerUI: null,
      bitmovinPlayerKey: process.env.REACT_APP_BITMOVIN_PLAYER_KEY,
      bitmovinAnalyticsKey: process.env.REACT_APP_BITMOVIN_ANALYTICS_KEY,
      bitmovinVideoId: process.env.REACT_APP_BITMOVIN_VIDEO_ID,
      playerId: 'bitmovin-player-' + uuid(),
      playerIsMuted: false
    };

    this.updateVideoSrc = this.updateVideoSrc.bind(this)
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      nextProps.src !== prevState.src
    ) {
      return {
        src: nextProps.src
      };
    }
    else return null;
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.src !== this.props.src
    ) {
      this.setState(
        {
          src: this.props.src
        },
        () => this.updateVideoSrc());
    }
  }

  updateVideoSrc() {
    const {src, bitmovinVideoId, bitmovinPlayer} = this.state;
    const playerSource = {
      hls: src.url,
      analytics: {
        videoId: bitmovinVideoId,
        title: src.title
      }
    }
    if (bitmovinPlayer) {
      console.log('Loading: ', playerSource.hls);
      bitmovinPlayer.load(playerSource).catch(e => console.log(e));
    }
  }

  componentDidMount() {
    this.setupPlayer();
  }

  componentWillUnmount() {
    this.destroyPlayer();
  }

  setupPlayer() {
    const playerConfig = {
      ui: false,
      key: this.state.bitmovinPlayerKey,
      analytics: {
        key: this.state.bitmovinAnalyticsKey
      }
    }
    const player = new Player(document.getElementById(this.state.playerId), playerConfig);
    const ui = UIFactory.buildDefaultUI(player);
    player.on(PlayerEvent.SourceLoaded, () => {
      console.log('Source Loaded.');
      player.play();
    });
    player.on(PlayerEvent.Play, () => {
      console.log(`Playing: ${this.state.src.url}`);
    });
    player.on(PlayerEvent.Paused, () => {
      console.log('Paused.');
    });
    player.on(PlayerEvent.Error, (err) => {
      console.log(err);
    });
    player.on(PlayerEvent.Muted, () => {
      this.setState({ playerIsMuted: true });
    });
    player.on(PlayerEvent.Unmuted, () => {
      this.setState({ playerIsMuted: false });
    });
    player.mute();
    this.setState({ bitmovinPlayer: player, bitmovinPlayerUI: ui }, () => this.updateVideoSrc());
  }

  destroyPlayer() {
    if (this.state.bitmovinPlayerUI != null) {
      this.state.bitmovinPlayerUI.release();
      this.setState({ bitmovinPlayerUI: null });
    }
    if (this.state.bitmovinPlayer != null) {
      this.state.bitmovinPlayer.destroy();
      this.setState({ bitmovinPlayer: null });
    }
  }

  render() {
    return (
      <div id={this.state.playerId} />
    );
  }

}
